import Spinner from 'components/Spinner';
import styles from './Fallback.module.scss';

const BuilderFallback = () => (
  <div className={styles.container}>
    <Spinner />
  </div>
);

export default BuilderFallback;
